import { connect } from 'react-redux';
import {
    getIsComparateurApporteur
} from '../../../../../../redux/selectors/init/init.selectors.js';
import EmailClient from './EmailClient';

const mapStateToProps = (state) => {
    return {
        isComparateur: getIsComparateurApporteur(state),
    };
};

const EmailClientContainer = connect(mapStateToProps)(EmailClient);

export default EmailClientContainer;
